import React, { useState, useMemo, useEffect } from 'react';
import { OptionsType } from '../../utils/customSelectUtils';
import { commonBackInfo, dealwithVideoTag } from '../../utils';
import CustomSelect from '../../components/CustomSelect';
import type { SingleCommonType } from '../../types';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { videoTagPlaceholder } from '../../constants/placeholder';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function VideoTagSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  filterOptions,
  lang,
}: SingleCommonType) {
  // 搜索的数据
  const [searchValue, setSearchValue] = useState('');
  const { formatMessage } = useIntl();
  const options: OptionsType = useMemo(() => {
    return dealwithVideoTag(filterOptions, searchValue, lang);
  }, [filterOptions, searchValue, lang]);

  const basicOptions: OptionsType = useMemo(() => {
    return dealwithVideoTag(filterOptions, '', lang);
  }, [filterOptions, lang]);

  const {
    selects: selectVideoTag,
    setSelects: setSelectVideoTag,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'video_labels',
    options: basicOptions.map((item) => item.value),
  });
  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();

    onChange?.(
      'videoTag',
      commonBackInfo(
        { video_labels: selectVideoTag },
        { videoTag: text },
        { isAll, needChangeEntity: true },
      ),
    );
  }, [selectVideoTag, formatMessage]);

  return (
    <div className={`hashtag-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={videoTagPlaceholder[lang]}
        options={options}
        matchButtonWidth
        basicOptions={basicOptions}
        allShowModal="text"
        allLabel={formatMessage({ id: 'Video Tag' })}
        searchInfo={[searchValue, setSearchValue]}
        selectOptionsInfo={[selectVideoTag, setSelectVideoTag]}
        onClear={() => setSelectVideoTag([])}
        pointKey={FilterButtonPoint.videoTag}
      ></CustomSelect>
    </div>
  );
}
